module.exports = __webpack_public_path__ + "pc-static/img/3.6d1a012.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3.jpg
// module id = ihpy
// module chunks = 1